export const RESOURCE_SCHEMAS = {
  businesses: {
    label: "Empresas",
    singular: "Empresa",
    titleField: "name",
    columns: ["name", "category", "featured"],
    fields: [
      { name: "name", label: "Nome", type: "text", required: true },
      { name: "category", label: "Categoria", type: "select-category" },
      { name: "description", label: "Descrição", type: "textarea" },
      { name: "cover", label: "Foto de capa", type: "image" },
      { name: "logo", label: "Logotipo", type: "image" },
      { name: "address", label: "Endereço", type: "text" },
      { name: "phone", label: "Telefone", type: "text" },
      { name: "hours", label: "Horário de funcionamento", type: "text" },
      { name: "whatsapp", label: "WhatsApp (só números com DDI)", type: "text", placeholder: "5583999990000" },
      { name: "wa_button_text", label: "Texto do botão do WhatsApp", type: "wa_button" },
      { name: "instagram", label: "Instagram (link)", type: "text" },
      { name: "facebook", label: "Facebook (link)", type: "text" },
      { name: "featured", label: "Empresa em destaque", type: "switch" },
      { name: "order", label: "Ordem", type: "number" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  services: {
    label: "Serviços",
    singular: "Serviço",
    titleField: "name",
    columns: ["name", "category", "professional"],
    fields: [
      { name: "name", label: "Nome do serviço", type: "text", required: true },
      { name: "category", label: "Categoria", type: "select-category" },
      { name: "professional", label: "Profissional / Empresa responsável", type: "text" },
      { name: "description", label: "Descrição", type: "textarea" },
      { name: "image", label: "Foto", type: "image" },
      { name: "address", label: "Endereço (se houver)", type: "text" },
      { name: "phone", label: "Telefone", type: "text" },
      { name: "whatsapp", label: "WhatsApp (só números com DDI)", type: "text", placeholder: "5583999990000" },
      { name: "wa_button_text", label: "Texto do botão do WhatsApp", type: "wa_button" },
      { name: "instagram", label: "Instagram (link)", type: "text" },
      { name: "hours", label: "Horário de atendimento", type: "text" },
      { name: "price", label: "Preço (deixe em branco se não houver)", type: "text" },
      { name: "order", label: "Ordem", type: "number" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  products: {
    label: "Produtos",
    singular: "Produto",
    titleField: "name",
    columns: ["name", "price", "featured", "available"],
    fields: [
      { name: "name", label: "Nome do produto", type: "text", required: true },
      { name: "business_id", label: "Loja responsável", type: "select-business" },
      { name: "price", label: "Preço", type: "price" },
      { name: "description", label: "Descrição completa", type: "textarea", big: true },
      { name: "image", label: "Foto principal", type: "image" },
      { name: "photos", label: "Mais fotos (galeria)", type: "images" },
      { name: "contact_link", label: "Link de contato ou WhatsApp", type: "text", placeholder: "https://wa.me/5583999990000 ou https://..." },
      { name: "contact_enabled", label: "Mostrar botão de contato", type: "switch" },
      { name: "contact_button_text", label: "Texto do botão de contato", type: "wa_button", presets: ["Pedir", "Comprar", "Tenho interesse", "Saiba mais", "Chamar no WhatsApp", "Fazer pedido"], placeholder: "Ex: Pedir, Comprar, Tenho interesse..." },
      { name: "featured", label: "Produto em destaque (aparece na página inicial)", type: "switch" },
      { name: "available", label: "Disponível", type: "switch" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  promotions: {
    label: "Promoções",
    singular: "Promoção",
    titleField: "title",
    columns: ["title", "new_price", "valid_until"],
    fields: [
      { name: "title", label: "Título", type: "text", required: true },
      { name: "business_id", label: "Empresa", type: "select-business" },
      { name: "description", label: "Descrição completa", type: "textarea", big: true },
      { name: "old_price", label: "Preço normal", type: "price" },
      { name: "new_price", label: "Preço promocional", type: "price" },
      { name: "image", label: "Foto principal", type: "image" },
      { name: "photos", label: "Mais fotos (galeria)", type: "images" },
      { name: "button_text", label: "Texto do botão da oferta (página inicial)", type: "wa_button", presets: ["Ver oferta", "Comprar agora", "Saiba mais", "Aproveitar promoção", "Conferir oferta"], placeholder: "Ex: Ver oferta" },
      { name: "details_enabled", label: "Mostrar botão \"Ver detalhes\" no perfil da empresa", type: "switch" },
      { name: "details_button_text", label: "Texto do botão de detalhes (perfil da empresa)", type: "wa_button", presets: ["Ver detalhes", "Saiba mais", "Ver promoção", "Conferir"], placeholder: "Ex: Ver detalhes" },
      { name: "wa_enabled", label: "Mostrar botão do WhatsApp na página da promoção", type: "switch" },
      { name: "whatsapp", label: "WhatsApp da promoção (opcional — se vazio, usa o da empresa)", type: "text", placeholder: "5583999990000" },
      { name: "wa_button_text", label: "Texto do botão do WhatsApp", type: "wa_button", presets: ["Falar com a empresa", "Comprar pelo WhatsApp", "Tenho interesse", "Quero aproveitar", "Pedir pelo WhatsApp", "Entrar em contato"], placeholder: "Ex: Falar com a empresa" },
      { name: "wa_message", label: "Mensagem automática do WhatsApp (opcional)", type: "textarea", placeholder: "Olá! Vi a promoção no Divulga Pocinhos e tenho interesse." },
      { name: "valid_until", label: "Validade", type: "date" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  coupons: {
    label: "Cupons",
    singular: "Cupom",
    titleField: "title",
    columns: ["code", "title", "valid_until"],
    fields: [
      { name: "title", label: "Título", type: "text", required: true },
      { name: "business_id", label: "Empresa", type: "select-business" },
      { name: "code", label: "Código", type: "text", required: true },
      { name: "type", label: "Tipo", type: "select", options: [
        { value: "percent", label: "Porcentagem (%)" },
        { value: "value", label: "Valor em reais (R$)" },
        { value: "free_shipping", label: "Frete grátis" },
        { value: "custom", label: "Benefício personalizado" },
      ] },
      { name: "value", label: "Valor (número)", type: "text" },
      { name: "description", label: "Descrição", type: "textarea" },
      { name: "rules", label: "Regras", type: "textarea" },
      { name: "image", label: "Imagem/Logo", type: "image" },
      { name: "valid_until", label: "Validade", type: "date" },
      { name: "featured", label: "Destaque", type: "switch" },
      { name: "order", label: "Ordem", type: "number" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  categories: {
    label: "Categorias",
    singular: "Categoria",
    titleField: "name",
    columns: ["name", "icon", "order"],
    fields: [
      { name: "name", label: "Nome", type: "text", required: true },
      { name: "icon", label: "Ícone", type: "icon" },
      { name: "image", label: "Imagem personalizada (opcional)", type: "image" },
      { name: "order", label: "Ordem", type: "number" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  news: {
    label: "Notícias",
    singular: "Notícia",
    titleField: "title",
    columns: ["title", "category", "date"],
    fields: [
      { name: "title", label: "Título", type: "text", required: true },
      { name: "category", label: "Categoria", type: "text" },
      { name: "summary", label: "Resumo", type: "textarea" },
      { name: "content", label: "Texto completo", type: "textarea", big: true },
      { name: "image", label: "Imagem", type: "image" },
      { name: "date", label: "Data", type: "date" },
      { name: "active", label: "Publicado", type: "switch" },
    ],
  },
  events: {
    label: "Eventos",
    singular: "Evento",
    titleField: "name",
    columns: ["name", "date", "location"],
    fields: [
      { name: "name", label: "Nome", type: "text", required: true },
      { name: "description", label: "Descrição", type: "textarea", big: true },
      { name: "image", label: "Imagem", type: "image" },
      { name: "date", label: "Data", type: "text", placeholder: "24/06/2026" },
      { name: "time", label: "Horário", type: "text", placeholder: "19h00" },
      { name: "location", label: "Localização", type: "text" },
      { name: "contact", label: "Contato", type: "text" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  tourist_spots: {
    label: "Pontos Turísticos",
    singular: "Ponto Turístico",
    titleField: "name",
    columns: ["name", "location", "order"],
    fields: [
      { name: "name", label: "Nome", type: "text", required: true },
      { name: "description", label: "Descrição completa", type: "textarea", big: true },
      { name: "location", label: "Localização", type: "text" },
      { name: "cover", label: "Foto de capa", type: "image" },
      { name: "photos", label: "Fotos (galeria)", type: "images" },
      { name: "map_link", label: "Link de localização (mapa)", type: "text" },
      { name: "order", label: "Ordem", type: "number" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  jobs: {
    label: "Vagas",
    singular: "Vaga",
    titleField: "title",
    columns: ["title", "company", "location"],
    fields: [
      { name: "title", label: "Cargo", type: "text", required: true },
      { name: "company", label: "Empresa", type: "text" },
      { name: "location", label: "Cidade/Local", type: "text" },
      { name: "contract_type", label: "Tipo de contratação / estágio", type: "text", placeholder: "CLT, Estágio, Temporário..." },
      { name: "schedule", label: "Horário", type: "text", placeholder: "Seg-Sex, 8h às 17h" },
      { name: "salary", label: "Remuneração", type: "text", placeholder: "A combinar / R$ 1.500" },
      { name: "description", label: "Descrição completa", type: "textarea", big: true },
      { name: "activities", label: "Atividades", type: "textarea" },
      { name: "requirements", label: "Requisitos", type: "textarea" },
      { name: "benefits", label: "Benefícios", type: "textarea" },
      { name: "whatsapp", label: "WhatsApp (só números com DDI)", type: "text", placeholder: "5583999990000" },
      { name: "email", label: "E-mail para currículo", type: "text", placeholder: "vagas@empresa.com" },
      { name: "date", label: "Data", type: "date" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  rentals: {
    label: "Casas para Alugar",
    singular: "Casa",
    titleField: "title",
    columns: ["title", "location", "price"],
    fields: [
      { name: "title", label: "Título", type: "text", required: true },
      { name: "location", label: "Bairro/Localização", type: "text" },
      { name: "description", label: "Descrição", type: "textarea" },
      { name: "bedrooms", label: "Quartos", type: "number" },
      { name: "price", label: "Valor (mês)", type: "price" },
      { name: "photos", label: "Fotos", type: "images" },
      { name: "contact", label: "Contato (texto do botão)", type: "text" },
      { name: "whatsapp", label: "WhatsApp (só números)", type: "text" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  commercial_spots: {
    label: "Pontos Comerciais",
    singular: "Ponto Comercial",
    titleField: "title",
    columns: ["title", "location", "price"],
    fields: [
      { name: "title", label: "Título", type: "text", required: true },
      { name: "location", label: "Localização", type: "text" },
      { name: "description", label: "Descrição", type: "textarea" },
      { name: "size", label: "Tamanho", type: "text", placeholder: "60m²" },
      { name: "price", label: "Valor (mês)", type: "price" },
      { name: "photos", label: "Fotos", type: "images" },
      { name: "phone", label: "Telefone", type: "text" },
      { name: "whatsapp", label: "WhatsApp (só números)", type: "text" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  banners: {
    label: "Banners",
    singular: "Banner",
    titleField: "title",
    columns: ["title", "order"],
    fields: [
      { name: "title", label: "Título", type: "text", required: true },
      { name: "text", label: "Texto", type: "text" },
      { name: "button", label: "Texto do botão", type: "text" },
      { name: "link", label: "Link", type: "text" },
      { name: "image", label: "Imagem", type: "image" },
      { name: "order", label: "Ordem", type: "number" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
  reels: {
    label: "Reels (Vídeos)",
    singular: "Vídeo",
    titleField: "title",
    columns: ["title", "business_id", "featured", "order", "active"],
    fields: [
      { name: "title", label: "Título do vídeo", type: "text", required: true },
      { name: "video", label: "Vídeo (vertical 9:16)", type: "video", required: true },
      { name: "business_id", label: "Empresa", type: "select-business" },
      { name: "description", label: "Legenda / descrição", type: "textarea" },
      { name: "thumbnail", label: "Capa (opcional)", type: "image" },
      { name: "button_enabled", label: "Mostrar botão de contato no vídeo", type: "switch" },
      { name: "button_text", label: "Texto do botão", type: "wa_button", presets: ["Falar com a empresa", "Pedir pelo WhatsApp", "Tenho interesse", "Saiba mais", "Comprar"], placeholder: "Ex: Falar com a empresa" },
      { name: "button_link", label: "Link do botão (opcional — se vazio, usa o WhatsApp da empresa)", type: "text", placeholder: "https://wa.me/5583999990000" },
      { name: "featured", label: "Vídeo em destaque", type: "switch" },
      { name: "order", label: "Ordem", type: "number" },
      { name: "active", label: "Ativo", type: "switch" },
    ],
  },
};
